import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'How to Increase Your Credit Limit',
    title1: 'Apply for your first loan',
    title2: 'Repay on time',
    title3: 'Upload profile photo',
    title4: 'Apply for a bigger loan amount',
    title5: 'Refer Smart Credit app to friends',
    title6: 'Share your story',
  },
  id: {
    title: 'Cara Menaikkan Limit Kredit Pintar',
    title1: 'Ajukan pinjaman pertamamu',
    title2: 'Lunasi pinjaman tepat waktu',
    title3: 'Masukkan foto profil',
    title4: 'Ajukan pinjaman lebih banyak',
    title5: 'Refer teman Anda untuk download',
    title6: 'Bagikan ceritamu',
  },
})

const IncreaseProces = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/product/increase1.png',
      title: t('title1'),
    },
    {
      img: '/images/product/increase2.png',
      title: t('title2'),
    },
    {
      img: '/images/product/increase3.png',
      title: t('title3'),
    },
    {
      img: '/images/product/increase4.png',
      title: t('title4'),
    },
    {
      img: '/images/product/increase5.png',
      title: t('title5'),
    },
    {
      img: '/images/product/increase6.png',
      title: t('title6'),
    },
  ]
  return (
    <IncreaseStyle>
      <div className="title">{t('title')}</div>
      <div className="item-list" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 80} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <LazyLoad>
                    <img src={item.img} alt={item.title} />
                  </LazyLoad>
                </div>
                <div className="subtitle">{item.title}</div>
              </div>
            </Reveal>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <img src={item.img} alt={item.title} />
                    </LazyLoad>
                  </div>
                  <div className="subtitle">{item.title}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </IncreaseStyle>
  )
}

export default IncreaseProces

const IncreaseStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 64px auto 0;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      margin-bottom: 32px;
      width: 272px;
      margin: 0 auto 32px;
    }
    .item-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;
      .item {
        width: 272px;
        height: 268px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: center;
        margin-bottom: 50px;
        background-image: url('/images/product/proces-bg.png');
        background-size: 100% 100%;
        .img {
          margin: 24px auto 12px;
          width: 144px;
          height: 144px;
        }
        .subtitle {
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 36px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 0 150px 60px;
    text-align: center;
    max-width: 1440px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 40px;
    }
    .item-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 360px;
        height: 292px;
        display: flex;
        flex-direction: column;
        padding: 0 30px;
        align-items: center;
        margin-bottom: 30px;
        background-image: url('/images/product/proces-bg.png');
        background-size: 100% 100%;
        .img {
          margin: 24px auto 12px;
          width: 144px;
          height: 144px;
        }
        .subtitle {
          width: 232px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 36px;
        }
      }
    }
  }
`
